import { Form, Icon, List, Modal, Text } from "../../../../components";
import Localization from "../../../../localization";
import { AddHomeLayout } from "../../../../layouts";
import { useCallback, useRef } from "react";
import useViewModel from "../../viewModel";
import { SVGs } from "../../../../assets";
import { Flex } from "antd";

const Homes = () => {
  const {
    home = {},
    homes = [],
    addHome = () => {},
    createHome = () => {},
  } = useViewModel();
  const addInfoModalRef = useRef();
  const addInfoFormRef = useRef();
  const addHomeModalRef = useRef();

  const renderItem = useCallback((item) => {
    return (
      <List.Item onClick={() => addInfoModalRef.current.open(item)}>
        <Flex justify="space-between" className="flex-column-mobile">
          <List.Item.Meta
            title={item.title}
            description={item.address || Localization.general.na}
          />
          {!!item.connectId && (
            <>
              <div className="m-10-t" />
              <Text
                color="secondary"
                weight={"600"}
                style={{ whiteSpace: "nowrap" }}
                children={Localization.general.connected}
              />
            </>
          )}
        </Flex>
      </List.Item>
    );
  }, []);

  const renderAddInfoModal = useCallback(
    (data) => (
      <div>
        <Text
          color="secondary"
          className="m-20-b"
          children={Localization.add_home.placeholder_3}
        />
        <Form
          ref={addInfoFormRef}
          initialValues={{ note: home.note }}
          fields={[
            {
              name: "note",
              type: "textarea",
              autoSize: { minRows: 4, maxRows: 6 },
              placeholder: Localization.add_home.add_info_placeholder,
              label: `${Localization.general.additional_info} (${Localization.general.optional})`,
            },
          ]}
        />
        <Form.Submit
          type="primary"
          className="m-30-t"
          title={Localization.general.save}
          onClick={async () => {
            await addHome({
              ...data,
              ...addInfoFormRef.current.getFieldsValue(),
            });
            addInfoModalRef.current.close();
          }}
        />
      </div>
    ),
    [home.note]
  );

  return (
    <div>
      {!!homes.length && (
        <List
          className="m-20-b"
          dataSource={homes}
          itemLayout="vertical"
          renderItem={renderItem}
        />
      )}
      <List
        dataSource={[{}]}
        renderItem={() => (
          <List.Item
            onClick={() => addHomeModalRef.current.open()}
            children={
              <List.Item.Meta
                title={Localization.service.add_home_item_title}
                description={Localization.service.add_home_item_desc}
                avatar={
                  <Text level={1}>
                    <Icon component={SVGs.plusHollowCircleFilledComp} />
                  </Text>
                }
              />
            }
          />
        )}
      />
      <Modal
        ref={addHomeModalRef}
        title={Localization.service.add_home_modal_title}
        child={() => (
          <AddHomeLayout
            onSave={async (data) => {
              await createHome(data);
              addHomeModalRef.current.close();
            }}
          />
        )}
      />
      <Modal
        ref={addInfoModalRef}
        child={renderAddInfoModal}
        title={Localization.general.additional_info}
      />
    </div>
  );
};

export default Homes;
